import { lazy } from "react";
import { lazyRetry } from "../../helpers";

export default lazy(() =>
  lazyRetry(() => import("./CreateEditOrderPage"), "order-wizard-page-new")
);
